import { Formule, SaisieFormule, SaisiePersonnalisation } from './../../models/form-state.model';
export interface OfferCustomizationState {
  saisiePersonnalisation: SaisiePersonnalisation;
  isValid: boolean;
  SaisieFormule: SaisieFormule;
  ValeurAssuree: string | undefined; 
  FormuleRecommandee?: Formule;
}

export const initialState: OfferCustomizationState = {
  saisiePersonnalisation: {
    MontantValeurObjets2000: undefined,
    ProtectionJuridique: false,
    ProtectionJuridiqueMontant: 0,
    ProtectionVelos: false,
    ProtectionVelosMontant: 0,
    ProtectionNomades: false,
    ProtectionNomadesMontant: 0,
    AssuranceScolaire: undefined,
    AssuranceScolaireMontant: 0,
    ValeurANeuf: false,
    ValeurANeufMontant: 0,
    Vol: false,
    VolMontant: 0
  },
  SaisieFormule: {
    FormuleSelectionnee: undefined,
    CodePromo: undefined,
    ValeurMensuelle: 0,
    ValeurAnnuelle: 0
  },
  FormuleRecommandee: Formule.F1,
  ValeurAssuree: undefined,
  isValid: false
};
